import Vue from 'vue';
import VueRouter from 'vue-router'

import Home from "../components/home/Home.vue";
import AboutThaw from "../components/about-thaw/AboutThaw.vue";
import Drivers from "../components/drivers/Drivers.vue";
import Passengers from "../components/passengers/Passengers.vue";
import OurArea from "../components/our-area/OurArea.vue";
import News from "../components/news/News.vue";
import NewsHome from "../components/news/NewsHome.vue";
import Gallery from "../components/gallery/Gallery.vue";
import ContactUs from "../components/contact-us/ContactUs.vue";
import WinnerOf100Trip from "../components/news/articles/WinnerOf100Trip.vue";
import CouldYouBeOur100thPassenger from "../components/news/articles/CouldYouBeOur100thPassenger.vue";
import NotJustACarScheme from "../components/news/articles/NotJustACarScheme.vue";
import DriversGetTogether from "../components/news/articles/DriversGetTogether.vue";
import ThawGrowing from "../components/news/articles/ThawGrowing.vue";
import GoodPracticeGuide from "../components/useful-information/GoodPracticeGuide.vue";
import Privacy from "../components/useful-information/Privacy.vue";
import TandC from "../components/useful-information/TandC.vue";
import NotFound from "../components/NotFound.vue";
import Accessibility from "../components/useful-information/Accessibility.vue"
const routes = [
  { path: "/", component: Home },
  { path: "/about-thaw", component: AboutThaw },
  { path: "/drivers", component: Drivers },
  { path: "/passengers", component: Passengers },
  { path: "/our-area", component: OurArea },
  {
    path: "/news",
    component: News,
    children: [
      {
        path: "",
        component: NewsHome,
      },
      {
        path: "winner-100th-trip",
        component: WinnerOf100Trip,
      },
      {
        path: "could-you-be-our-100th-passenger",
        component: CouldYouBeOur100thPassenger,
      },
      {
        path: "not-just-a-car-scheme",
        component: NotJustACarScheme,
      },
      {
        path: "drivers-get-together",
        component: DriversGetTogether,
      },
      {
        path: "thaw-growing",
        component: ThawGrowing,
      },
    ],
  },
  { path: "/our-gallery", component: Gallery },
  { path: "/contact-us", component: ContactUs },
  { path: "/good-practice-guide-for-volunteers", component: GoodPracticeGuide },
  { path: "/privacy-policy", component: Privacy },
  { path: "/terms-of-use", component: TandC },
  { path: "/accessibility", component: Accessibility },
  { path: "*", component: NotFound },
];
Vue.use(VueRouter);
export default new VueRouter({
  mode: "history",
  routes,
});